export default __webpack_public_path__ + "static/media/icon-next-step-email.fa40d04c.svg";